import template from './calendarFilters.html';
import controller from './calendarFilters.controller';
import './calendarFilters.scss';

let calendarFiltersComponent = {
  restrict: 'E',
  bindings: {
    onChangeFilters: '&',
    isMobileApp: '<'
  },
  template,
  controller
};

export default calendarFiltersComponent;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/components/calendarFilters/calendarFilters.component.js